<template>
  <div>
    <h1>Impressum</h1>
    <template v-if="isSpendeappFs">digitalespende</template>
    <template v-else>spende.app</template> ist eine Marke der Digital.Wolff, Plötz & Co GmbH.<br>
    <br>
    <template v-if="isSpendeappFs">
      Sie ist Betreiber dieses Spendengerätes und Vermittler der Zahlungsdienstleistung. Alle Zahlungen gehen direkt auf das Konto der teilnehmenden Organisation.
    </template>
    <template v-else>
      Die Digital.Wolff GmbH ist Betreiber dieser Web-App und Vermittler der Zahlungsdienstleistung. Alle Zahlungen gehen direkt auf das Konto der teilnehmenden Organisation.<br>
    </template>
    <br>
    <b>Angaben gemäß § 5 TMG</b><br>
    Digital.Wolff, Plötz & Co GmbH<br>
    Geschäftsführer: Dr. Martin C. Wolff, Henryk Plötz, Hannah Jo Wolff<br>
    USt-ID: DE315450913<br>
    Regensburger Straße 3, 10777 Berlin,
    <a
      v-if="isSpendeappFs"
      href="mailto:fullscreen@digitalwolff.de"
    >
      fullscreen@digitalwolff.de
    </a>
    <a
      v-if="!isSpendeappFs"
      href="mailto:spendeapp@digitalwolff.de"
    >
      spendeapp@digitalwolff.de
    </a>
  </div>
</template>
<script>
import config from "@/config"

export default {
  name: 'Imprint',
  computed: {
    isSpendeappFs () {
      return config.spendeApp.variant === 'spendeapp-fs'
    }
  }
}
</script>
<style scoped lang="stylus">
@import '../styles/main'
.content
  overflow: auto
  padding-left: 3em
  padding-right: 3em
  padding-bottom: 3em
  top: 3em
  bottom: 0
  position: fixed
</style>
